// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_26-6";
export var headerCell = "_26-2";
export var rowWrapper = "_26-4";
export var stickyAggregationCell = "_26-a";
export var stickyAggregationRow = "_26-7";
export var stickyColumnCell = "_26-9";
export var stickyColumnHeaderCell = "_26-8";
export var table = "_26-1";
export var virtualRowWrapper = "_26-5";
export var virtualTableContainer = "_26-0";
export var white = "_26-3";